<div id="nuovo-ristorante" class="section nuovo-ristorante">
  <div class="content-body">
    <div class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        @if (edit) {
        <h1 class="mb-0">{{ "restaurant.edit_title" | translate }}</h1>
        } @else {

        <h1 class="mb-0">{{ "restaurant.new_title" | translate }}</h1>
        }
      </div>
      <form [formGroup]="form" class="form">
        <div class="double">
          <div class="fieldset">
            <label for="name">{{
              "restaurant.restaurant_name" | translate
            }}</label>
            <input
              formControlName="name"
              pInputText
              placeholder="{{ 'restaurant.insert_name' | translate }}"
              style="width: 100%"
              type="text"
            />
          </div>
          <div class="fieldset">
            <label for="picture">{{
              "restaurant.restaurant_image" | translate
            }}</label>
            <input
              formControlName="img_url"
              pInputText
              placeholder="{{ 'restaurant.insert_image' | translate }}"
              style="width: 100%"
              type="text"
            />
          </div>
        </div>
        <div class="double">
          <div class="fieldset">
            <label for="globalIdIn">{{
              "restaurant.global_id_in" | translate
            }}</label>
            <input
              formControlName="global_id_in"
              pInputText
              placeholder="{{ 'restaurant.insert_global_id_in' | translate }}"
              style="width: 100%"
              type="text"
            />
          </div>
          <div class="fieldset">
            <label for="globalIdOut">{{
              "restaurant.global_id_out" | translate
            }}</label>
            <input
              formControlName="global_id_out"
              pInputText
              placeholder="{{ 'restaurant.insert_global_id_out' | translate }}"
              style="width: 100%"
              type="text"
            />
          </div>
        </div>
        <div class="double">
          <div class="fieldset">
            <label for="myItalianPercentage">{{
              "restaurant.myitalian_percentage" | translate
            }}</label>
            <p-inputNumber
              inputId="myItalianPercentage"
              formControlName="myitalian_percentage"
              placeholder="{{
                'restaurant.insert_myitalian_percentage' | translate
              }}"
              [style]="{ width: '100%' }"
              [min]="0"
              [max]="100"
              suffix="%"
            />
          </div>
          <div class="fieldset">
            <label for="infoDeck">{{
              "restaurant.info_deck" | translate
            }}</label>
            <input
              pInputText
              inputId="infoDeck"
              formControlName="info_deck"
              placeholder="{{ 'restaurant.info_deck' | translate }}"
              [style]="{ width: '100%' }"
            />
          </div>
        </div>
        @if(!edit){

        <div class="fieldset">
          <label for="ship">{{ "restaurant.ship" | translate }}</label>
          <p-select
            formControlName="fk_ship"
            [options]="ships"
            optionLabel="name"
            [style]="{ width: '100%' }"
            placeholder="{{ 'restaurant.select_ship' | translate }}"
            optionValue="code"
            [readonly]="edit"
            [filter]="true"
          />
        </div>
        }

        <div class="table ships">
          <div class="ca-card">
            <p-table
              #tablesTable
              [value]="tables"
              [paginator]="true"
              [rows]="5"
              [tableStyle]="{ width: '100%' }"
              styleClass="p-datatable-sm p-datatable-striped"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="name">
                    {{ "restaurant.table_name" | translate }}
                    <p-sortIcon field="name" />
                  </th>
                  <th pSortableColumn="capacity">
                    {{ "restaurant.table_capacity" | translate }}
                    <p-sortIcon field="capacity" />
                  </th>
                  <th pSortableColumn="min_limit">
                    {{ "restaurant.table_minimum_capacity" | translate
                    }}<p-sortIcon field="min_limit" />
                  </th>
                  @if (edit) {

                  <th pSortableColumn="fk_status">
                    {{ "status" | translate }}<p-sortIcon field="fk_status" />
                  </th>
                  }
                  <th>{{ "restaurant.actions" | translate }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product let-i="rowIndex">
                <tr>
                  <td>{{ product.name }}</td>
                  <td>{{ product.capacity }}</td>
                  <td>{{ product.min_limit }}</td>
                  @if(edit){

                  <td>
                    @if(product.fk_status == 9){
                    <div class="dot success"></div>
                    <!-- <i class="pi pi-check" style="font-size: 1.5rem"></i>  -->
                    } @else if(product.fk_status == 10){
                    <div class="dot error"></div>
                    <!-- <i class="pi pi-times" style="font-size: 1.5rem"></i> -->
                    }
                  </td>
                  }
                  <td>
                    <p-button
                      [text]="true"
                      [pTooltip]="'edit' | translate"
                      tooltipPosition="top"
                      icon="pi pi-pencil"
                      (onClick)="editTable(product)"
                    />
                    @if(edit){ @if(product.fk_status == 9){
                    <p-button
                      [text]="true"
                      [pTooltip]="'disable' | translate"
                      icon="pi pi-power-off"
                      tooltipPosition="top"
                      (onClick)="deactivateTable(product)"
                    />
                    } @else if(product.fk_status == 10) {
                    <p-button
                      [text]="true"
                      [pTooltip]="'enable' | translate"
                      tooltipPosition="top"
                      icon="pi pi-play"
                      (onClick)="activateTable(product)"
                    />} @else{
                    <p-button
                      [text]="true"
                      icon="pi pi-trash"
                      (onClick)="deleteTable(product, i)"
                    />
                    } } @else {
                    <p-button
                      [text]="true"
                      icon="pi pi-trash"
                      (onClick)="deleteTable(product, i)"
                    />
                    }
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="paginatorright">
                <p-button
                  type="button"
                  label="{{ 'restaurant.add_table' | translate }}"
                  icon="pi pi-plus"
                  styleClass="p-button-text"
                  (onClick)="AddTable()"
                />
              </ng-template>
            </p-table>
          </div>
        </div>
      </form>
      <div class="buttons">
        <button class="costa-button outline" type="button" (click)="Back()">
          {{ "cancel" | translate }}
        </button>
        @if(edit){
        <button
          class="costa-button"
          type="button"
          [disabled]="!form.valid"
          (click)="editRestaurant()"
        >
          {{ "save" | translate }}
        </button>
        } @else {
        <button
          class="costa-button"
          type="button"
          [disabled]="!form.valid"
          (click)="createRestaurant()"
        >
          {{ "save" | translate }}
        </button>

        }
      </div>
    </div>
  </div>
</div>
